module.exports = "../../../../platform/assets/pageMainIcon/business_yewuchulilei6.svg";